import gql from "graphql-tag";

const APPLY_TO_POOL_WHITELIST = gql`
    mutation applyToPoolWhitelist(
        $pool_id: String!
    ) {
        applyToPoolWhitelist (
            applyToPoolWhitelistInput: {
                pool_id: $pool_id
            }
        ) {
            allocatedTickets
            walletId
        }
    }
`

export default APPLY_TO_POOL_WHITELIST;